import {pollHub} from "./ajax-poll-hub.js";
import {updateHubUI} from "./hub-update-events.js";
console.log('HUB called ===============================');

function updateHubTabsCssState(activeTab) {
  if (!activeTab) {
    return;
  }

  const $activeTab = $(activeTab);
  const $tabsWrap = $activeTab.closest('.tabs-wrap');
  if (!$tabsWrap.length) {
    return;
  }

  const activeTabId = $activeTab.attr('id') || $activeTab.data('id') || '';
  const classPrefix = 'hub-active-tab-';

  $tabsWrap.removeClass(function (_, className) {
    return (className.match(/\bhub-active-tab-[^\s]+/g) || []).join(' ');
  });

  if (activeTabId) {
    $tabsWrap.addClass(classPrefix + activeTabId);
  }
  $tabsWrap.attr('data-active-tab', activeTabId);

  // Global hook for any tab-related custom script/styles in Event Hub pages.
  $(document).trigger('hub:tab-changed', {
    activeTab: $activeTab[0],
    tabsWrap: $tabsWrap[0],
    activeTabId
  });
}

function initHubTabHooks() {
  $('.tabs-wrap').each(function () {
    const $activeTab = $(this).find('.tab.active').first();
    if ($activeTab.length) {
      updateHubTabsCssState($activeTab[0]);
    }
  });

  $('body').on('click', '.tabs-wrap .tab:not(.active)', function () {
    const clickedTab = this;

    // Run after the common tab handler toggles active classes.
    requestAnimationFrame(() => {
      const $tabsWrap = $(clickedTab).closest('.tabs-wrap');
      const $activeTab = $tabsWrap.find('.tab.active').first();
      updateHubTabsCssState($activeTab.length ? $activeTab[0] : clickedTab);
    });
  });
}

initHubTabHooks();

(async () => {
  try {
    
        const liveEventsMatchDataUrl = window.liveEventsUrl;
    // Access the global `lscrUrl` variable set by PHP
//    const livescoreDataUrl = window.lscrUrl;
//    const liveMatchesDataUrl = window.liveMatchesUrl;
//    if (!livescoreDataUrl) {
//        //return if no data is fetched;
//        //console.log('!livescoreDataUrl');
//        return;
//    }
//    // Fetch the JSON data from the URL
//    const response = await fetch(livescoreDataUrl);
//
//    if (!response.ok) {
//      throw new Error(`Failed to fetch data: ${response.statusText}`);
//    }
//
//    // Parse the JSON response
//    const data = await response.json();
////    console.log('Fetched LS Data:', data);
//
//    // Use the data in your component
//    loadLivescoreData(data);
    
    if (!liveEventsMatchDataUrl) {
        return;
    } else {
        //pollHub(liveEventsMatchDataUrl, 10000);        
        pollHub(liveEventsMatchDataUrl, 5000);        
    }
    
  } catch (error) {
    console.error('Error fetching data:', error);
  }
})();